import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Modal } from "semantic-ui-react";
import PromiseButton from "../../components/element/PromiseButton";
import TourDeliver from "../../stores/TourDeliver";
import Sidebar from "./Sidebar";

@observer
class BusinessSolution extends Component {
  getConfirm() {
    const { store } = this.props;

    if (!store.showRedirectToBusinessSolutionConfirm) {
      return null;
    }

    // Prevent closing the modal while saving.
    const onCancel = () => {
      if (store.saving) {
        return;
      }

      // close this modal
      store.setShowRedirectToBusinessSolutionConfirm(false);
    };

    return (
      <Modal size="small" open onClose={() => onCancel()}>
        <Modal.Header>
          <div>
            <strong>Publish Tour</strong> &gt; Business Solution Dashboard
          </div>
        </Modal.Header>
        <Modal.Content>
          <div>
            <p>Tour will be published and you will be redirected to your Business Solution dashboard.</p>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <PromiseButton
            positive
            icon="checkmark"
            labelPosition="right"
            content="Continue"
            onClick={() => store.publishBusinessSolutionManagedTour()}
          />
          <span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a
              href="#"
              onClick={event => {
                event.preventDefault();
                onCancel();
              }}
            >
              Cancel
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </Modal.Actions>
      </Modal>
    );
  }

  render() {
    const { store, modalOpen, openModalCallback, closeModalCallback } = this.props;

    return (
      <div>
        {this.getConfirm()}
        <button
          type="button"
          style={{
            fontSize: "1em",
            textTransform: "none",
            minWidth: "140px",
          }}
          onClick={() => openModalCallback()}
          className="button default"
        >
          Delivery Manager
        </button>
        <Modal open={modalOpen} closeIcon="close" onClose={() => closeModalCallback()}>
          <Modal.Header>
            <strong>Delivery Manager</strong>
            <div className="sub-header">
              <strong>Delivery Options</strong> &gt; Business Solution Dashboard
            </div>
          </Modal.Header>
          <Modal.Content>
            <div className="ui two column very relaxed grid">
              <div
                className="column"
                style={{
                  position: "relative",
                }}
              >
                <p>Please note that tour related fees will be charged using your Business Solution account.</p>
                <div className="vertical-divider" />
              </div>
              <Sidebar auditLogs={store.auditLogs} tourNotes={store.tourNotes} customerNotes={store.customerNotes} />
            </div>
          </Modal.Content>
          <Modal.Actions>
            <PromiseButton
              className="default"
              onClick={() => {
                if (store.isDelivered) {
                  // redirect to business solution page
                  window.location = store.businessSolutionUrl;

                  // return a promise that never resolves so the PromiseButton shows the loading
                  // spinner until the user is redirected.
                  return new Promise(() => {});
                }

                // open confirm modal
                store.setShowRedirectToBusinessSolutionConfirm(true);

                // consistent return
                return Promise.resolve();
              }}
            >
              {store.isDelivered ? "Business Solution" : "Publish Tour"}
            </PromiseButton>{" "}
            or{" "}
            <a
              onClick={e => {
                e.preventDefault();
                closeModalCallback();
              }}
              href="#"
            >
              cancel
            </a>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

BusinessSolution.propTypes = {
  store: PropTypes.instanceOf(TourDeliver),
  modalOpen: PropTypes.bool,
  openModalCallback: PropTypes.func.isRequired,
  closeModalCallback: PropTypes.func.isRequired,
};

export default BusinessSolution;
